export enum RelatedToStorageFeesValues {
  OTHER = "OTHER",
  FIRST_YEAR_STORAGE = "FIRST_YEAR_STORAGE",
  POST_FIRST_YEAR_STORAGE = "POST_FIRST_YEAR_STORAGE"
}

export enum WhoWillReceiveCareValues {
  DONOR = "DONOR",
  ME = "MEMBER",
  LEGAL_PARTNER = "LEGAL_PARTNER",
  NON_MARRIED_PARTNER = "NON_MARRIED_PARTNER",
  GESTATIONAL_CARRIER = "GESTATIONAL_CARRIER",
  BIRTH_PARENT = "BIRTH_PARENT"
}

export enum IntendedCarrierValues {
  ME = "MEMBER",
  LEGAL_PARTNER = "LEGAL_PARTNER",
  NON_MARRIED_PARTNER = "NON_MARRIED_PARTNER",
  GESTATIONAL_CARRIER = "GESTATIONAL_CARRIER"
}

export enum JourneySubTypeValues {
  MEDICATIONS = "MEDICATION",
  ONLINE_CARE = "ONLINE_CARE",
  LABS = "LABS",
  IN_PERSON_CARE = "IN_PERSON_CARE",
  NUTRITION_COUNSELING = "NUTRITION_COUNSELING",
  TEMP_REG_PRODUCTS = "TEMP_REG_PRODUCTS",
  BINDERS_OR_PACKERS = "BINDERS_OR_PACKERS",
  TRAVEL = "TRAVEL"
}
